
  export interface 在庫調整型 {
    対象: boolean;
    調整後管理外: boolean;
    商品コード: string;
    JANコード: string;
    メーカー名: string;
    商品名: string;
    規格容量: string;
    経過措置日: Date | null;
    経過措置区分: string;
    採用品管理対象外フラグ: string;
    在庫データ件数: number;
    調整先商品コード: string;
    調整先JANコード: string;
    調整先メーカー名: string;
    調整先商品名: string;
    調整先規格容量: string;
    調整先経過措置日: string;
  }

  export interface 在庫調整登録依頼内容型 {
    商品コード: string;
    調整先商品コード: string;
    調整後管理外: boolean;
  }

  export interface 在庫調整登録依頼型 {
    在庫調整登録依頼一覧: 在庫調整登録依頼内容型[];
  }

  export function to在庫調整依頼内容型(record: 在庫調整型): 在庫調整登録依頼内容型 {
    return {
        商品コード: record.商品コード,
        調整先商品コード: record.調整先商品コード,
        調整後管理外: record.調整後管理外,
    };
  }

  export interface 在庫調整登録者結果型 {
    登録者一覧: 在庫調整登録者型[];
    利用者: 在庫調整登録者型;
  }

  export interface 在庫調整登録者型 {
    アカウント名: string | null;
    氏名: string;
  }

  export interface 在庫調整移動先型 {
    部署コード: string | null;
    部署名: string;
  }

  export interface 在庫調整検索依頼型 {
    採用品管理対象外のみ: boolean;
  }

  export interface 在庫調整検索結果型 {
    在庫調整検索結果一覧: 在庫調整型[];
    アラートメッセージ: string;
  }

  export enum バラ単位区分型 {
    包装単位 = '包装単位',
    包装数量 = '包装数量',
  }
